<template>
  <div>
    <settings-section-title id="edit" class="i-mb-4"
      >View API Key</settings-section-title
    >
    <breadcrumbs :items="breadcrumbs"></breadcrumbs>

    <div v-if="hasEditPermissions" class="i-mt-12 view-form">
      <label
        for="key-name"
        class="i-text-subheading-2 i-text-neutral-120 i-mb-2"
        >Name</label
      >
      <b-form-input
        id="key-name"
        v-model="currentKey.name"
        class="i-form-input"
        plaintext
      ></b-form-input>
      <label
        for="key-description"
        class="i-mt-10 i-text-subheading-2 i-text-neutral-120 i-mb-2"
        >Description (optional)</label
      >
      <b-form-textarea
        id="key-description"
        v-model="currentKey.description"
        class="i-form-textarea"
        plaintext
      ></b-form-textarea>

      <div class="d-flex i-mt-12">
        <i-button
          text="Back"
          size="lg"
          type="neutral"
          subtype="subtle"
          @button-click="back()"
        ></i-button>
      </div>
    </div>

    <div v-else class="i-mt-12">
      <p>You must be an administrator to view this API key</p>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { iButton } from '@inscribe/signal';
import Breadcrumbs from '@/shared/components/Breadcrumbs';
import SettingsSectionTitle from '@/V2/settings/shared/SettingsSectionTitle';

export default {
  components: {
    Breadcrumbs,
    'i-button': iButton,
    'settings-section-title': SettingsSectionTitle,
  },
  data() {
    return {
      apiKey: '',
      currentKey: {},
      breadcrumbs: [
        {
          text: 'Settings',
          to: { name: 'settings-view' },
        },
        {
          text: 'API Keys',
          to: { name: 'api-settings-list-keys' },
        },
        {
          text: 'View API Key',
          active: true,
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      hasEditPermissions: 'isOrgAdmin',
    }),

    ...mapState(['currentUser']),
  },
  mounted() {
    this.apiKey = this.$route.params.api_key;
    this.currentKey = this.currentUser.organisation.api_keys.filter(
      (key) => key.key === this.apiKey,
    )[0];
  },
  methods: {
    back() {
      this.$router.push({
        name: 'api-settings-list-keys',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.view-form {
  max-width: 500px;
}
</style>
